var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFiAlertIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4376 8.04087L3.79177 37.4992C3.42795 38.1293 3.23545 38.8436 3.23341 39.5711C3.23138 40.2987 3.41988 41.0141 3.78016 41.6461C4.14044 42.2782 4.65995 42.8049 5.287 43.1739C5.91404 43.5429 6.62677 43.7412 7.35427 43.7492H42.6459C43.3734 43.7412 44.0862 43.5429 44.7132 43.1739C45.3403 42.8049 45.8598 42.2782 46.22 41.6461C46.5803 41.0141 46.7688 40.2987 46.7668 39.5711C46.7648 38.8436 46.5723 38.1293 46.2084 37.4992L28.5626 8.04087C28.1912 7.42859 27.6683 6.92237 27.0443 6.57105C26.4202 6.21972 25.7162 6.03516 25.0001 6.03516C24.284 6.03516 23.58 6.21972 22.9559 6.57105C22.3319 6.92237 21.809 7.42859 21.4376 8.04087V8.04087Z",
    stroke: "#D14343",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 18.75V27.0833",
    stroke: "#D14343",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25 35.418H25.0208",
    stroke: "#D14343",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiAlertIcon);
export default __webpack_public_path__ + "static/media/fi_alert-icon.b3823d202eafaae32a756e971821cc55.svg";
export { ForwardRef as ReactComponent };